<template>
  <div class="DataTables DeriveProjectFormComponent ">

    <p><span v-if="isAll"><b-spinner small label="alert" type="grow" variant="danger"></b-spinner> {{lang.infotext_3}}</span></p>
    <span v-if="!isAll">
      <p>{{lang.infotext_1}}: {{categoryName}}</p>
      <LoaderComponent  v-if="!isData"></LoaderComponent>
      <div :id="id"></div>
      
      <p>{{lang.infotext_3}}</p>
      <br><br>
      <p><b-badge class="badge badge-blue badge">Request</b-badge> - {{lang.infotext_2}}</p>
    </span>
  </div>
</template>
<script>
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import DesignEntryTypes from '@/constants/DesignEntryTypes'
  import ProjectPropertiesType from "@/constants/ProjectPropertiesType";

    export default {
        name: "DeriveProjectFormComponent",
        props:{
          lang: Object,
          source: String
        },
        components: {

          LoaderComponent
        },
        data () {
          return {

            mainTable: "",
            id: "DeriveProjectFormComponent",
            properties: [],
            partDatas: [],
            projectTypes: [""],
            projectFiles: null,
            
            listAllRevisionFiles: {},
            listAllImageTriggers: {},
          }
        },
        computed: {
          isAll(){
            if (this.$store.getters.selectedTreeProjectItemObject.categoryId == 1){
              return true;
            }
            return false;
          },
          isData(){
            return this.properties.length != 0;
          },
          categoryId(){
            return this.$store.getters.selectedTreeProjectItemObject.categoryId;
          },
          categoryName(){
            return this.$store.getters.selectedTreeProjectItemObject.category;
          },
          revisionId(){

            
            return this.$route.query.revisionId;
          },
          variant(){
            if (this.$store.getters.s_skinVariant == "dark"){
              return "light";
            }else{
              return "dark";
            }
            
          }
        },
        created () {
          

          this.getproperties();

        },
        watch: {
          categoryId: function(newVal, oldVal){

            this.getproperties();
          }

        },
        updated() {

        },
        mounted: function () {

        },
        methods: {
          back() {
            let to = this.$route.query.from;

            
            

            const query = {
              from: this.$route.path,
              to: to,

            }

            this.$router.push({ path: to, query: query });
          },
          
          getproperties(){

            let vue = this;
            this.properties = [];

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProjectType")
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK"){

                vue.projectTypes = [""];
                result.data.forEach(element => {
                    vue.projectTypes.push(element.type);
                });

      
                let obj = {
                  categoryId: vue.categoryId

                }

                vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getProperties", obj)
                .then(function(result) {
                  
                  console.log(result)

                  if (result.status == "OK"){

                    for (let i = 0, lei = result.data.length; i < lei; i++) {

                      if (result.data[i].origins != "descendant") {
                        vue.properties.push(result.data[i]);
                      }

                    }
                    //vue.propertiesRevNumbers.push(result.revision)
                    vue.listAllImageTriggers[vue.revisionId] = false;


                    vue.getDataForForm();
                  }

                })


              }
            })

            

          },
          getDataForForm(){

            let vue = this;

            const obj = {
              revisionId: this.revisionId

            }

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_getProject", obj)
            .then(function(result) {
              
              console.log(result)

              if (result.status == "OK"){

                result.data.sort(function(a, b){return a.priority-b.priority});

                vue.partDatas = result.data;



                vue.buildTable();
              }

            })

          },
          validateValues(obj) {
            
            let vue = this;

            let arr = [obj];

            this.$store.dispatch(this.$store.getters.sectionPrefix + "_createNewProjectValidation", arr)
              .then((result) => {

                console.log(result);

                if (result.status == "OK") {
                  if (result.data.valid == false) {


                    for (let i = 0, lei = result.data.violatedRules.length; i < lei; i++) {

                      vue.displayValidationRules(result.data.violatedRules[i])
                    }
                  } else {
                    vue.resetValidationRules(obj);
                  }
                }



              })


          },
          displayValidationRules(obj) {

            let id = "value__" + obj.propertyId;
            let elem = document.getElementById(id);
            elem.classList.add("warning");

            let idInvalidFeedback = id + "__invalid";
            let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
            elemInvalidFeedback.setAttribute("style", "display: block");
            elemInvalidFeedback.innerHTML = obj.message;

          },
          resetValidationRules(obj) {

            let id = "value__" + obj.propertyId;
            let elem = document.getElementById(id);
            elem.classList.remove("warning");

            let idInvalidFeedback = id + "__invalid";
            let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
            elemInvalidFeedback.setAttribute("style", "display: none");
            elemInvalidFeedback.innerHTML = "";
          },
          checkFormValidationAfterLoad() {


            let editParts = document.getElementsByClassName('new-part');

            for (var i = 0; i < editParts.length; i++) {

              let temp = editParts[i].id.split("__")

              const validObj = {
                propertyId: temp[1],
                value: editParts[i].value,
              }
              this.validateValues(validObj);


            }

          },
          buildTable(){
         



            this.$store.dispatch("resetPropertyToSaving");

            for (let i = 0, lei = this.properties.length; i < lei; i++){
              let value = "";
              for (let j = 0, lej = this.partDatas.length; j < lej; j++){

                if (this.partDatas[j].id == this.properties[i].propertyId){

                  this.properties[i].value = this.partDatas[j].value != null ? this.partDatas[j].value.display : "";
                  
                  break;
                }else{

                  this.properties[i].value = "";
                }

              }


              let obj = {
                propertyId: this.properties[i].propertyId,
                value: this.properties[i].value,
                type: this.properties[i].type,
                isRequiredOnRequest: this.properties[i].isRequiredOnRequest
              }
              
              this.$store.dispatch("addPropertyToSaving", obj);



            }

            var tableplace = document.getElementById(this.id);
            if (tableplace == null) {
              return;
            }
            while (tableplace.firstChild) {
                tableplace.removeChild(tableplace.firstChild);
            }

            var table = document.createElement("table");
            table.setAttribute("id", "t_" + this.id);
            table.setAttribute("class", "table table-striped table-bordered");
            tableplace.appendChild(table)

            var tr = document.createElement("tr");

            var thead = document.createElement("thead");
            thead.appendChild(tr);

            table.appendChild(thead);

            let vue = this;


            let cols =  [
              { "data": "propertyId" },
              { "data": "priority" },
              { "data": "name" },
              { "data": "value" },

            ]

            let columns = [
              {
                name: "Id",
                alignInColumn: "left",

              },
              {
                name: "Priority",
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Name,
                alignInColumn: "left",

              },
              {
                name: this.lang.table_header_Value,
                alignInColumn: "left",

              },



            ]




            var columnDefs = [];

            for (var i = 0, len = columns.length; i < len; i++){

              let classname = '_dt-body-'+ columns[i].alignInColumn;

              let  el = {
                  targets: i,
                  className: classname,
                  render: function ( data, type, row, meta ) {
                    if (data == null) {
                      data = "";
                    }

                    data = $.fn.dataTable.render.text().display(data);
                    if (data.display != undefined) {
                      data.display = $.fn.dataTable.render.text().display(data.display);
                    }

                    if (meta.col == 1){
                      return data;
                    }
                    if (meta.col == 2){
                      let required = "<span class=\"required\">";
                      
                        if (row.isRequiredOnRequest == true){
                          required += "<b-badge class=\"badge badge-blue\">Request</b-badge>";
                        }
                        
                        required += "</span>"
                      
                      return data + "   " + required;
                    }
                    if (meta.col == 3){
                                            

                      
                      if (row.type == ProjectPropertiesType.TEXT){

                        let str = "";
                        str += "<div role=\"group\"  class=\"input-group input-group-sm\">";
                        str += "<input data-type=\""+row.type+"\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str;
                       
                      }else if (row.type == ProjectPropertiesType.PROJECTTYPE){
                        
                        let str = "";
                        str += "<div role=\"group\"  class=\"input-group input-group-sm\">";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\" >";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                        
                        return str;
                      
                      
                      }else if (row.type == ProjectPropertiesType.COMMENT){
                        let str = "";
                        str += "<div role=\"group\"  class=\"input-group input-group-sm\">";
                        str += "<textarea disabled=\"disabled\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\" style=\"resize: none; overflow - y: scroll; height: 50px; \"></textarea>";
                        str += "</div>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                        return str;
                      }else if (row.type == ProjectPropertiesType.PROJECTNUMBER){
                        
                        let str = "";
                        str += "<div role=\"group\"  class=\"input-group input-group-sm\">";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                        
                        return str;
                      } else if (row.type == ProjectPropertiesType.PROJECTNAME) {

                        let str = "";
                        str += "<div role=\"group\"  class=\"input-group input-group-sm\">";
                        str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                        return str;
                      } else if (row.type == ProjectPropertiesType.DESIGNENTRYTYPE) {
                        let str = "<select data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part entry-type-select\" id=\"value__" + row.propertyId + "\">";

                        const tab = ["", DesignEntryTypes.CIS, DesignEntryTypes.HDL];
                        for (let j = 0, lej = tab.length; j < lej; j++) {

                          let selected = "";
                          
                          if (tab[j] == data) {
                            selected = "selected=\"selected\""
                          }
                          str += "<option value=\"" + tab[j] + "\" " + selected + ">" + tab[j] + "</option>";
                        }

                        str += "</select>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";

                        return str;
                      }else{
                        let str = "";
                        str += "<div role=\"group\"  class=\"input-group input-group-sm\">";
                        str += "<input data-type=\""+row.type+"\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control new-part\" type=\"text\" id=\"value__" + row.propertyId + "\" value=\"" + row.value + "\">";
                        str += "</div>";
                        str += "<datalist id=\"datalist__" + row.propertyId + "\" ></datalist>";
                        str += "<div class=\"invalid\" id=\"value__" + row.propertyId + "__invalid\"></div>";
                
                        return str; 
                      }

                    }

                    return data;
                  }
                }

              columnDefs.push(el);


              var th = document.createElement("th");
              tr.appendChild(th);
              
              var br = document.createElement("br");
              th.appendChild(br);
              var tx = document.createTextNode(columns[i].name)
              th.appendChild(tx);


            }


            var json = {};
            json.paging = false;
            json.info = false;
            json.dom = 'f<t>';
            json.data= this.properties;
            json.myColumnFormats = columns;
            json.select = false;
            json.columns = cols;
            json.columnDefs = columnDefs;
            json.order = [1, "asc"];
            json.initComplete = function () {

              vue.checkFormValidationAfterLoad();
            }

            if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
                this.mainTable.destroy();
                
            }



            this.mainTable = $('#t_'+this.id).DataTable(json);


            this.mainTable.columns.adjust().draw();

            //hide first column in table
            this.mainTable.column( 0 ).visible( false );
            this.mainTable.column( 1 ).visible( false );

            //search input change view
            var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

            while (searchplace.firstChild) {

              if (searchplace.firstChild.textContent == "Search:"){
                  searchplace.removeChild(searchplace.firstChild);
                  break;
              }

            }

            searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
            searchplace.firstChild.setAttribute("class", "form-control form-control-sm")



            let editParts = document.getElementsByClassName('new-part');

            for (var i = 0; i < editParts.length; i++) {
              editParts[i].addEventListener('input', function (e){

                let temp = this.id.split("__");
                let propertyId = temp[1];
                let type = $(this).attr("data-type");
                let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest") === "true";
                
                

                let obj = {
                  propertyId: propertyId,
                  value: this.value,
                  type: type,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: this.value,
                }
                vue.validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);
              })
            }


            


          },

        }

    }
</script>
<style lang="scss">
  @import "./../../scss/_custom.scss";

  .DeriveProjectFormComponent{
    table{

      padding: 0px !important;

    }
    table th {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table td {
      padding: 0.2rem !important;

    }

    .dataTables_filter{
      font-size: 10px;
    }
    .searcher{
      float: left;
    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{

      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $redfont;
    }
    .red-img{
      background-color: $red;
      border: 0px;
    }
    .green{
      color: $green;
    }
    .green-img{
      background-color: $green;
      border: 0px;
    }
    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }

    .btn{
      height: 26.8px;
    }
    td{
      word-break: break-all;
    }
    input-group{
      min-width: 200px;

    }
    input-group-prepend{
      height: 26.8px !important;
      widows: 24px;
    }
    .img-thumbnail{
      width: 100px;
    }
    .form-control{
      height: 26.8px;
    }
    .required{
      float: right;
      margin: 2px;
    }
    .type-select{
      padding-top: 5px;
      font-size: 0.7rem;
      padding-left: 5px;
    }
    .warning{
      border-color: $redfont !important;
    }
    .invalid{
      color: $redfont;
      font-size: 0.7rem;
      display: none;
    }
    .entry-type-select{
      font-size: 0.7rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/DeriveProjectFormComponent.vue